/**
 * 侧栏内容 SSOT（与 docs/ops/PERMISSION_ALIGNMENT_SSOT.md §6 一致）：
 * - **menuId 集合**：以后端 GET /coffee/menu/nav 为准；merge 仅改树形，不得删 nav 已授权节点。
 * - **禁止**用 sessionStorage.permissions 里的权限码对 nav 已返回的 menuId 做二次过滤（会与 coffee_menu.perms 不一致，如 billing）。
 * - 下列 enName 仅用于「前端 merge 硬注入」项：须 nav 也含同名节点才保留。
 */
export const RBAC_SIDEBAR_EN_NAMES = new Set([
  'memberHqGroup',
  'memberHqDashboard',
  'memberHqFinance',
  'memberHqOps',
  'distributorReportGroup',
  'distributorDashboard',
  'distributorMembers',
  'distributorProfit',
  'linuxAutoOps',
  'linuxAutoEquipment',
  'linuxAutoRemoteOps',
  'linuxAutoProfileConfig',
  'linuxAutoDataBilling',
  'linuxAutoModelRegistry',
  'linuxAutoPartnerDelivery',
  'linuxAutoFleetMonitor',
  'linuxAutoDbcEntitlement',
  'linuxAutoCabinFeatures',
  'linuxAutoCanAutoMatch',
  'x600hProductionOrder',
  'deviceProductionOrder',
  'agentPermissionSteward',
  'platformReleaseControl',
  'equipmentModelRepair',
  'partnerApiAdmin'
])

export function menuNodeEnName (node) {
  if (!node) return ''
  return node.enName != null ? String(node.enName).trim() : ''
}

/** 收集 nav API 树中全部 menuId（侧栏内容 SSOT 白名单） */
export function collectNavMenuIds (nodes, out) {
  const ids = out || new Set()
  if (!Array.isArray(nodes)) return ids
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n || n.id == null) continue
    ids.add(String(n.id))
    if (Array.isArray(n.menuList) && n.menuList.length) {
      collectNavMenuIds(n.menuList, ids)
    }
  }
  return ids
}

export function isNavAuthorizedMenuId (menuId, navAuthorizedIds) {
  if (menuId == null || !navAuthorizedIds) return false
  return navAuthorizedIds.has(String(menuId))
}

export function menuTreeContainsEnName (nodes, enName) {
  if (!enName || !Array.isArray(nodes)) return false
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i]
    if (!n) continue
    if (menuNodeEnName(n) === enName) return true
    if (Array.isArray(n.menuList) && n.menuList.length && menuTreeContainsEnName(n.menuList, enName)) {
      return true
    }
  }
  return false
}

/** 移除 nav 未授权、却被前端 merge 硬塞的 RBAC 菜单项 */
export function stripUnassignedRbacSidebarMenus (nodes, rawApiMenus) {
  if (!Array.isArray(nodes)) return
  const raw = Array.isArray(rawApiMenus) ? rawApiMenus : []
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) {
      nodes.splice(i, 1)
      continue
    }
    const en = menuNodeEnName(n)
    if (en && RBAC_SIDEBAR_EN_NAMES.has(en) && !menuTreeContainsEnName(raw, en)) {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      stripUnassignedRbacSidebarMenus(n.menuList, raw)
      if (!n.menuList.length && !/\S/.test(String(n.url || ''))) {
        nodes.splice(i, 1)
      }
    }
  }
}

/**
 * @param {object} node
 * @param {Record<string, function(): boolean>} checks enName -> predicate
 */
export function shouldShowSidebarNodeByEn (node, checks) {
  const en = menuNodeEnName(node)
  if (!en || !checks[en]) return true
  return checks[en]()
}

/**
 * @param {Set<string>|null} navAuthorizedIds nav API 已授权的 menuId；命中则跳过 checks（SSOT 不二次过滤）
 */
export function pruneSidebarNodesByEnChecks (nodes, checks, navAuthorizedIds) {
  if (!Array.isArray(nodes) || !checks) return
  for (let i = nodes.length - 1; i >= 0; i--) {
    const n = nodes[i]
    if (!n) {
      nodes.splice(i, 1)
      continue
    }
    const navBound = isNavAuthorizedMenuId(n.id, navAuthorizedIds)
    if (!navBound && !shouldShowSidebarNodeByEn(n, checks)) {
      nodes.splice(i, 1)
      continue
    }
    if (Array.isArray(n.menuList) && n.menuList.length) {
      pruneSidebarNodesByEnChecks(n.menuList, checks, navAuthorizedIds)
      if (!n.menuList.length && !/\S/.test(String(n.url || ''))) {
        nodes.splice(i, 1)
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/sidebarPermissionFilter.js